export const LOAD_EQUIPMENT = "[USER_INFO] LOAD_EQUIPMENT";

export const UPDATE_EQUIPMENT_APP = "[USER_INFO] UPDATE_EQUIPMENT_APP";

export const UPDATE_SELECTED_EQUIPMENT = "[USER_INFO] UPDATE_SELECTED_EQUIPMENT";

export const UPDATE_PAGINATION = "[USER_INFO] UPDATE_PAGINATION";
